import React from "react";
import Chart from "react-apexcharts";
import CountUp from 'react-countup';
import { Link } from "react-router-dom";

import { WeeklyChart } from "./Components/WeeklyChart";
import { ExpenseChart } from "./Components/ExpenseChart";
import { creditCardData } from "./Components/CreditCardData";
import { SliderData } from "./Components/SliderData";
import { BalanceChart } from "./Components/BalanceChart";
import { RecentTransactionData } from "./Components/RecentTransactionData";
import MySlider from "./Components/Slider";

const Index = () => {
  return (
    <>
      {/* x---------------------------------x Credit-Cards And Recent Transaction x---------------------------------x */}
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 xl:gap-4 lg:gap-2 md:gap-2 gap-2 justify-center">
        {/* x---------------------------------x Credit-Cards Data x---------------------------------x */}
        {creditCardData.map((cardData, index) => (
          <div key={index}>
            <div className={`${cardData.h_class} sm:p-2 xl:p-4`}>
              {cardData.id === 0 ? (
                <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-dark sm:mb-0 mb-2">
                  {cardData.heading}
                </h3>
              ) : (
                <Link to="/" className="text-right text-lg sm:text-xl md:text-2xl font-extrabold hidden sm:block text-primary">
                  {cardData.heading}
                </Link>
              )}
            </div>
            <div className={`${cardData.id === 0 ? cardData.bg_color : "card-body"} rounded-2xl shadow-md overflow-hidden`}>
              <div className="mb-3">
                <div className={`p-4 ${cardData.text_color}`}>
                  <div className="flex justify-between items-center">
                    <div>
                      <h5 className="text-base sm:text-lg font-normal">Balance</h5>
                      <h4 className={`text-2xl font-bold ${cardData.text_color}`}>
                        $ <CountUp
                          className={`${cardData.text_color}`}
                          end={cardData.value}
                          duration={2} // Adjust duration as needed
                        />
                      </h4>

                    </div>
                    <div className="card-img">{cardData.cardIcon}</div>
                  </div>
                  <div className="flex justify-between items-center py-4 sm:py-5 md:py-6">
                    <div>
                      <h5 className="text-base sm:text-lg font-normal mb-1">CARD HOLDER</h5>
                      <h4 className={`text-2xl font-bold ${cardData.text_color}`}>{cardData.name}</h4>
                    </div>
                    <div>
                      <h5 className="text-base sm:text-lg font-normal mb-1 text-opacity-75">VALID THRU</h5>
                      <h4 className={`text-2xl font-bold ${cardData.text_color}`}>{cardData.expiry}</h4>
                    </div>
                  </div>
                </div>
                <div className={`border-t border-dashed border-${cardData.borderColor} px-4 sm:px-6 md:px-8 mt-5`}>
                  <div className="flex justify-between items-center py-2 sm:py-3 md:py-4">
                    <div>
                      <h4 className={`text-2xl lg:text-3xl font-bold ${cardData.text_color}`}>{cardData.cardNumber}</h4>
                    </div>
                    <div>{cardData.f_icon}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* x---------------------------------x Recent Transaction Card x---------------------------------x */}
        <div className="card">
          <div className="card-header">
            <h3 className="text-dark font-semibold text-xl md:text-2xl lg:text-2xl mb-4">Recent Transactions</h3>
          </div>
          <div className="card-body rounded-2xl p-3 grid grid-cols-1 justify-between gap-5 shadow-md">
            {RecentTransactionData.map((data, index) => (
              <div className="flex py-2 md:py-3 items-center text-dark" key={index}>
                <div className={`flex justify-center items-center w-14 h-14 rounded-full mr-2 ${data.IconBgColor}`}>
                  {data.icon}
                </div>
                <div>
                  <h5 className="text-xl lg:text-2xl font-medium">{data.heading}</h5>
                  <h4 className="text-secondary text-sm md:text-base font-normal">{data.date}</h4>
                </div>
                <div className="ml-auto">
                  <h4 className={`text-sm lg:text-base font-medium ${data.amountColor}`}>
                    $ <CountUp
                      end={data.amount}
                      duration={2}
                    />
                  </h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* x---------------------------------x Weekly Activity And Expense Statistics x---------------------------------x */}
      <div className="flex flex-wrap md:flex-nowrap gap-4 my-2 h-fit">
        {/* x---------------------------------x Weekly Activity x---------------------------------x */}
        <div className="xl:w-8/12 w-full">
          <div className="card">
            <div className="p-4 flex justify-between">
              <h3 className="text-dark text-lg md:text-xl lg:text-2xl font-semibold">Weekly Activity</h3>
            </div>
            <div className="card-body rounded-2xl mb-3 p-3">
              <div id="chart-two weekly_chart " className="text-dark">
                <Chart
                  options={WeeklyChart}
                  series={WeeklyChart.series}
                  type={WeeklyChart.chart.type}
                  height={WeeklyChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>

        {/* x---------------------------------x Expense Statistics x---------------------------------x */}
        <div className="xl:w-4/12 w-full">
          <div className="card">
            <div className="md:p-4 px-3 pb-2  flex justify-between">
              <h3 className="text-dark text-lg md:text-xl lg:text-2xl font-semibold">Expense Statistics</h3>
            </div>
            <div className="card-body rounded-2xl p-3 lg:p-10 flex  items-center justify-center h-96">
              <div id="chart-two-xl">
                <Chart
                  options={ExpenseChart}
                  series={ExpenseChart.series}
                  type={ExpenseChart.chart.type}
                  height={ExpenseChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* x---------------------------------x Quick Transfer And Balance History x---------------------------------x */}
      <div className="flex flex-wrap md:flex-nowrap gap-3">
        {/* x---------------------------------x Quick Transfer x---------------------------------x */}
        <div className="xl:w-5/12 w-full">
          <div className="rounded-xl">
            <div className="xl:p-4 flex justify-between">
              <h3 className="text-dark text-lg sm:text-2xl font-semibold">Quick Transfer</h3>
            </div>
            <div className="p-4 rounded-lg pt-5 relative card-body h-auto xl:h-[21.50rem]">
              <div className="flex flex-wrap m-0">
                <div className="w-10/12">
                  {/* Slider Section Start */}
                  <MySlider SliderData={SliderData} />
                  {/* Slider Section End */}
                </div>
                <div className="w-full">
                  <div className="flex justify-between items-center py-3">
                    <div>
                      <span className="text-base font-normal text-gray-400">Write Amount</span>
                    </div>
                    <div className="relative">
                      <div className="flex items-center justify-between">
                        <input
                          type="text"
                          id="amount" name="amount"
                          className="block w-full bg-light focus:outline-dashed outline-primary rounded-full border-0 py-1.5 pl-7 pr-20 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                          placeholder="525.50"
                          aria-label="Amount"
                        />
                        <span className="bg-primary text-white rounded-full py-2 px-6 flex items-center cursor-pointer absolute right-0">
                          <span className="mr-2">Send</span>
                          <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M16.0963 0.572034C16.1748 0.206511 15.8164 -0.101694 15.4669 0.0316926L0.303581 5.82017C0.121087 5.88985 0.000378397 6.06476 8.88017e-07 6.26009C-0.000376621 6.45546 0.11964 6.63084 0.301883 6.70121L4.56154 8.34637V13.5281C4.56154 13.7467 4.71163 13.9366 4.9243 13.9872C5.13554 14.0374 5.35582 13.9369 5.45485 13.7404L7.2166 10.2445L11.5159 13.4351C11.7774 13.6292 12.1533 13.5058 12.2485 13.1939C16.2627 0.0327312 16.0891 0.605098 16.0963 0.572034ZM12.3532 2.2305L4.96655 7.49106L1.78829 6.26359L12.3532 2.2305ZM5.50531 8.26599L11.944 3.6806C6.4036 9.52539 6.69296 9.21775 6.6688 9.25028C6.6329 9.29857 6.73125 9.11035 5.50531 11.5431V8.26599ZM11.541 12.2785L7.75659 9.46993L14.5993 2.25126L11.541 12.2785Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* x---------------------------------x Balance History x---------------------------------x */}
        <div className="xl:w-7/12 w-full" >
          <div className="card">
            <div className="card-header justify-between">
              <h3 className="text-dark text-lg sm:text-2xl font-semibold pb-4">Balance History</h3>
            </div>
            <div className="rounded-xl card-body p-4 mb-3 mb-sm-0 text-dark">
              <div
                id="chart-three"
              >
                <Chart
                  options={BalanceChart}
                  series={BalanceChart.series}
                  type={BalanceChart.chart.type}
                  height={BalanceChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
